import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '../_services/user.service';
import { WelcomeStoreService } from '../_services/welcome-store.service';

/**
 * The signup pages, reached again after the signup finished (browser Back from the welcome page, an old tab): they
 * would show the "account is being created" page or start a new signup. Only in a tab where the welcome page was
 * opened and someone is signed in; the merchant goes back to the welcome page, or to the dashboard once the store
 * exists. Anything else (a new visitor, a sign-in that sends an unverified account to the code step) is untouched.
 */
@Injectable({ providedIn: 'root' })
export class SignupFinishedGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService, private welcome: WelcomeStoreService) {}

  canActivate(): boolean | UrlTree {
    if (!this.welcome.welcomeOpened || !this.userService.currentUserObj?.token) return true;
    return this.router.parseUrl(this.welcome.existingStoreUrl ? '/' : '/welcome-store');
  }
}
